<template>
	<div class="background-container">
		<!-- <div class="foot"></div> -->
	</div>
</template>

<script>
export default {
	data() {
		return {

		};
	},
	methods: {
	}
}
</script>

<style lang="scss" scoped>
.background-container {
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 0;
	background-image: url('../assets/images/catfood2025/snow.png');
	/* 替换为实际图片路径 */
	background-size: cover;
	/* 或者可以使用 100% 100% 来确保背景填满容器 */
	animation: scrollBackground 11s linear infinite;

	/* 调整动画时间来改变速度 */
	.foot {
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		z-index: 1;
		background-image: url('../assets/images/catfood2024/bg/foot.png');
		background-size: cover;
	}
}

/* 定义滚动动画 */
@keyframes scrollBackground {
	from {
		background-position: 0 0;
	}

	to {
		background-position: 0 1200px;
		/* 调整这个值以匹配实际背景图像的高度 */
	}
}
</style>
